// Packages
import { Component, createRef } from "react";
import { Link, withRouter } from "react-router-dom";
import axios from "axios";
import moment from "moment";
//import { FormGroup } from "reactstrap";
import { FormGroup } from "react-bootstrap";

// Views
import SuperAdminDashboard from "../superAdmin/superAdminDashboard";
import ElevationScroll from "../schoolAdminPortal/ElevationScroll";

// Material UI
import Toolbar from "@material-ui/core/Toolbar";
import DatePicker from "react-datepicker";
import CssBaseline from "@material-ui/core/CssBaseline";
import Container from "@material-ui/core/Container";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import "react-datepicker/dist/react-datepicker.css";

// Assets
import backarrow from "../../assets/images/back-arrow.png";
import successimg from "../../assets/images/successimg.png";
// All Urls

// Services
import userService from "../../services/user.service";
import { BsXLg } from "react-icons/bs";
import { getFromLocalStorage } from "../../utils/webStorage";
import { Formik, Form, Field } from "formik";
import validationSchema from "../../Validation/ValidationSchemas";

import { Worker } from "@react-pdf-viewer/core";
import { Viewer } from "@react-pdf-viewer/core";
import "@react-pdf-viewer/core/lib/styles/index.css";
import { CircularProgress, Paper } from "@material-ui/core";
import CustomDropDown from "../../Common/FormFields/CustomDropDown";
import {
  paymentMethodList,
  paymentStatusList,
  schoolTypeOptions,
} from "../../utils/constant";
import FormikTextField from "../../Common/FormFields/FormikInputField";
import { connect } from "react-redux";
import {
  openConfirmationPopup,
  openFailDialog,
  openSuccessPopup,
} from "../../Redux/Actions/PopupActions";
import { ContentLayoutSpinner } from "../spinner/ContentLayoutSpinner";
import ContentLayoutHeader from "../../Common/ContentLayoutHeader";
class SchoolAdmin extends Component {
  constructor() {
    super();
    this.myref = createRef();
    this.state = {
      fields: {},
      errors: {},
      schoolsData: [],
      schoolTypeList: [],
      allSportsList: [],
      stateList: [],
      errors: {},
      selectedCOuntry: "",
      countryId: null,
      schoolId: null,
      paymentMethod: "",
      amount: "",
      note: "",
      startDate: "",
      validityInText: "",
      validityInNumber: "",
      uploadFilesInvoiceId: "",
      validityDate: "",
      showStatus: "",
      status: "",
      plan: "",
      anyMessage: "",
      selectedFile: null,
      fileAddress: null,
      uploadId: null,
      imagePreviewUrl: "",
      disabled: false,
      pdfError: "",
      pdfFile: null,
      isFileSelected: false,
      isFileUploaded: false,
      schoolType: "",
      paymentStatus: "",
    };
  }

  // for popup
  openDialog() {
    this.setState({ open: !this.state.open });
  }
  closeDialog() {
    this.setState({ open: !this.state.open });
  }

  openDialogCancel() {
    this.setState({ openCancel: !this.state.openCancel });
  }
  closeDialogCancel() {
    this.setState({ openCancel: !this.state.openCancel });
  }

  onSelect = (selectedList, selectedItem) => {
    var coaches = [];
    for (let i = 0; i < selectedList.length; i++) {
      coaches.push(selectedList[i].id);
      this.setState({ coaches });
    }
  };

  changeHandlerForLogo = (event) => {
    var showStatus = "uploading...";
    this.setState({ showStatus });
    this.selectedFile = event.target.files[0];
    let reader = new FileReader();
    let file = event.target.files[0];

    reader.onloadend = () => {
      this.setState({
        file: file,
        imagePreviewUrl: reader.result,
      });
    };

    reader.readAsDataURL(file);
    this.handleSubmissionForLogo();
  };

  handleSubmissionForLogo = () => {
    const { schoolId } = this.state;
    const { setFailPopUpInformation } = this.props;
    const currentUserId = getFromLocalStorage("currentUserId");
    const data = new FormData();
    data.append("file", this.selectedFile);
    data.append("userId", currentUserId);
    data.append("schoolId", schoolId);
    userService
      .uploadInvoice(data)
      .then((res) => {
        var uploadFilesInvoiceId = res.data.data[0].id;
        var showStatus = res.data.data[0].fileName;
        this.setState({
          uploadFilesInvoiceId,
          showStatus,
          isFileUploaded: true,
        });
        this.myref.current.setFieldValue("invoiceId", uploadFilesInvoiceId);
        this.myref.current.setFieldError("invoiceId", "");
      })
      .catch(() => {
        setFailPopUpInformation({
          open: true,
          message: "Something Went Wrong.",
        });
        this.setState({ isFileSelected: false });
      });
  };

  componentDidMount() {
    this.getAllSportsList();
    const payment = document.getElementById("Payments");
    if (payment) {
      payment.classList.add("active");
    }
  }
  getAllSportsList() {
    userService
      .getAllSchoolListing()
      .then((response) => {
        var schoolsData = response.data.data.schools;
        this.setState({ schoolsData });
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  ondateSet = (date) => {
    var dateSend = moment(date).format("YYYY-MM-DD");
    this.setState({
      validityDate: dateSend,
      startDate: date,
    });
    this.myref.current.setFieldValue("validity", dateSend);
    this.myref.current.setFieldError("validity", "");
  };

  validateForm() {
    const {
      amount,
      note,
      paymentMethod,
      paymentStatus,
      schoolId,
      uploadFilesInvoiceId,
      validityInNumber,
      validityInText,
      validityDate,
    } = this.state;
    let errors = {};
    let formIsValid = true;

    if (!amount) {
      formIsValid = false;
      errors["amount"] = "*Please enter amount.";
    }
    if (!note) {
      formIsValid = false;
      errors["note"] = "*Please enter notes.";
    }

    if (!paymentMethod) {
      formIsValid = false;
      errors["paymentMethod"] = "*Please select payment method.";
    }
    if (!paymentStatus) {
      formIsValid = false;
      errors["paymentStatus"] = "*Please select payment status.";
    }

    if (!schoolId) {
      formIsValid = false;
      errors["schoolId"] = "*Please select school.";
    }

    if (!validityDate) {
      formIsValid = false;
      errors["validityDate"] = "*Please select validity date.";
    }
    if (!uploadFilesInvoiceId) {
      formIsValid = false;
      errors["uploadFilesInvoiceId"] = "*Please add invoice.";
    }
    this.setState({
      errors: errors,
    });

    return formIsValid;
  }

  onSendBillDetails = ({
    schoolName,
    paymentMethod,
    amount,
    note,
    paymentStatus,
    validity,
    invoiceId,
  }) => {
    this.setState({
      submitting: true,
      disabled: true,
    });
    const { setSuccessPopupInformation, setFailPopUpInformation } = this.props;
    userService
      .billAddPost(
        amount,
        note,
        paymentMethod,
        paymentStatus,
        schoolName,
        invoiceId,
        validity
      )
      .then((response) => {
        this.setState({ disabled: false, submitting: false });
        setSuccessPopupInformation({
          successPopUp: {
            message: "Billing Details Added Successfully.",
            open: true,
            navigationLink: "/Payment",
          },
        });
      })
      .catch((error) => {
        setFailPopUpInformation({
          open: true,
          message: "Something Went Wrong.",
        });
        this.setState({ disabled: false, submitting: false });
      });
  };

  handleFileChange2 = (event) => {
    const allowedType = ["application/pdf"];
    let selectedFile = event.target.files[0];
    this.selectedFile = selectedFile;
    if (selectedFile) {
      if (selectedFile && allowedType.includes(selectedFile.type)) {
        let reader = new FileReader();
        reader.readAsDataURL(selectedFile);
        reader.onloadend = (e) => {
          this.setState({
            pdfFile: e.target.result,
            pdfError: "",
            isFileSelected: true,
          });
        };
      } else {
        this.setState({ pdfError: "Incorrect format" });
      }
    } else {
      this.setState({ pdfError: "File is not selected" });
    }
  };

  updateState = (name, value) => {
    this.setState({ [name]: value });
  };

  handleCancel = () => {
    const { setConfirmationPopupInformation } = this.props;
    setConfirmationPopupInformation({
      confirmationPopup: {
        open: true,
        message: "Are You Sure, You Want To Cancel?",
        btnColor: "red",
        btnText: "Yes",
        type: "Add Billing Details",
      },
    });
  };

  render(props) {
    const {
      schoolsData,
      showStatus,
      disabled,
      startDate,
      isFileSelected,
      pdfError,
      pdfFile,
      schoolType,
      paymentMethod,
      paymentStatus,
      submitting,
    } = this.state;
    return (
      <Formik
        innerRef={this.myref}
        initialValues={{
          schoolName: "",
          paymentMethod: "",
          note: "",
          amount: "",
          paymentStatus: "",
          validity: "",
          invoiceId: "",
        }}
        validationSchema={validationSchema.paymentDetailsSchema}
        onSubmit={(values) => this.onSendBillDetails(values)}
      >
        {(formik) => (
          <Form>
            <div className="content-layout add-sectionn pt-20 position-relative">
              <SuperAdminDashboard />
              <ContentLayoutHeader
                heading="Add New Billing"
                handleCancel={this.handleCancel}
                navigationLink="/Payment"
                btnText="Generate"
                loading={submitting}
                disabled={!formik.isValid}
              />
              <Container className="mg-top-70">
                <div name="adminRegistrationForm">
                  <div className="col-12 col-md-10 col-lg-5 mt-2">
                    <div className="white-card ">
                      <div className="row">
                        <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                          <FormGroup>
                            <label className="fmlabel mt-6 semi-bold fs-18">
                              School<span className="redstar">*</span>
                            </label>
                            <CustomDropDown
                              selected={schoolType}
                              setSelected={(value) =>
                                this.updateState("schoolType", value)
                              }
                              formik={formik}
                              fieldName="schoolName"
                              defaultSelectOption="Select School Type"
                              options={schoolsData}
                              fieldToShow="schoolName"
                              optionValue="id"
                              isDisabled="disabled"
                            />
                          </FormGroup>
                          <div className="clear10"> </div>
                          <FormGroup>
                            <label className="fmlabel mt-6 semi-bold fs-18">
                              Payment Method
                              <span className="redstar">*</span>
                            </label>
                            <CustomDropDown
                              selected={paymentMethod}
                              setSelected={(value) =>
                                this.updateState("paymentMethod", value)
                              }
                              formik={formik}
                              fieldName="paymentMethod"
                              defaultSelectOption="Select Payment Method"
                              options={paymentMethodList}
                              fieldToShow="name"
                              optionValue="name"
                              isDisabled="disabled"
                            />
                          </FormGroup>
                          <div className="clear10"></div>
                          <FormikTextField
                            label="Amount"
                            formik={formik}
                            fieldName="amount"
                            placeholder="Enter Amount"
                            labelFontSize="fs-18"
                          />
                          <FormikTextField
                            label="Note"
                            formik={formik}
                            fieldName="note"
                            placeholder="Type Here"
                            labelFontSize="fs-18"
                          />
                          <FormGroup>
                            <label className="fmlabel mt-6 semi-bold fs-18">
                              Payment Status
                              <span className="redstar">*</span>
                            </label>
                            <CustomDropDown
                              selected={paymentStatus}
                              setSelected={(value) =>
                                this.updateState("paymentStatus", value)
                              }
                              formik={formik}
                              fieldName="paymentStatus"
                              defaultSelectOption="Select Payment Status"
                              options={paymentStatusList}
                              fieldToShow="name"
                              optionValue="name"
                              isDisabled="disabled"
                            />
                          </FormGroup>
                          <div className="row">
                            <div className="col-lg-12">
                              <label className="fmlabel mt-6 semi-bold fs-16">
                                VALIDITY<span className="redstar"> * </span>
                              </label>
                              <div className="col-lg-12">
                                <DatePicker
                                  className={`form-control instn fs-16 regular w-100 olnone share-popup-input fmlabel ${
                                    formik.errors.validity && "is-invalid"
                                  } `}
                                  selected={startDate}
                                  onChange={(date) => this.ondateSet(date)}
                                  name="validity"
                                  dateFormat="MM/dd/yyyy"
                                  minDate={new Date()}
                                />
                                {formik.errors.validity && (
                                  <div className="errorMsg fs-14 medium">
                                    {formik.errors.validity}
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="clear20"> </div>
                    <div className="white-card">
                      <div class="row">
                        <label className="fs-16 semi-bold fmlabel mb-0">
                          UPLOAD DOCUMENTS
                        </label>
                        <label className="fs-8 semi-bold pl-3 mb-0">
                          {showStatus}
                        </label>

                        {!isFileSelected && (
                          <div class="uploadDoc-innercard text-center w-100 mt-2">
                            <div class="mRL">
                              <input
                                type="file"
                                name="photo"
                                id="upload-photo-1"
                                class="selectFileBtn"
                                multiple=""
                                onChange={this.handleFileChange2}
                              />
                              <div class="clear10"></div>
                              <label
                                for="upload-photo-1"
                                class="semi-bold  cp selectFileBtn-payment"
                              >
                                Browse
                              </label>
                            </div>
                          </div>
                        )}
                      </div>

                      {pdfError && (
                        <div className="errorMsg fs-14 medium">{pdfError}</div>
                      )}
                      {pdfFile && (
                        <div>
                          <div className="width-100 brd-black-1">
                            {pdfFile && (
                              <Worker workerUrl="https://unpkg.com/pdfjs-dist@2.6.347/build/pdf.worker.min.js">
                                <Viewer fileUrl={pdfFile} />
                              </Worker>
                            )}
                          </div>
                          <div className="mg-top-20 d-flex-align-cent column-gap-10 ">
                            {!this.state.isFileUploaded && (
                              <button
                                className="status-active"
                                onClick={() => this.handleSubmissionForLogo()}
                              >
                                Upload
                              </button>
                            )}
                            <button
                              className="status"
                              onClick={() =>
                                this.setState({
                                  pdfFile: null,
                                  isFileSelected: false,
                                  isFileUploaded: false,
                                })
                              }
                            >
                              Remove
                            </button>
                          </div>
                        </div>
                      )}

                      {formik.errors.invoiceId && (
                        <div className="errorMsg fs-14 medium">
                          {formik.errors.invoiceId}
                        </div>
                      )}

                      <div className="container"></div>
                    </div>
                    <div className="clear30"></div>
                  </div>
                </div>
              </Container>
            </div>
          </Form>
        )}
      </Formik>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setConfirmationPopupInformation: (obj) =>
      openConfirmationPopup(dispatch, obj),
    setSuccessPopupInformation: (obj) => openSuccessPopup(dispatch, obj),
    setFailPopUpInformation: (obj) => openFailDialog(dispatch, obj),
  };
};

const mapStateToProps = (state) => {
  return state;
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(SchoolAdmin)
);
